import VueI18Next from '@panter/vue-i18next';
import 'devextreme-intl';
import ElementUi from 'element-ui';
import elementLocale from 'element-ui/lib/locale';
import elementLangEnglish from 'element-ui/lib/locale/lang/en';
import { UNAUTHORIZED } from 'http-status';
import i18next from 'i18next';
import I18NextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import I18NextXhrBackend from 'i18next-xhr-backend';
import moment from 'moment';
import momentDurationFormat from 'moment-duration-format';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import App from '@/App.vue';
import axios from '@/axios-instance';
import config from '@/config';
import '@/css';
import { patchAsyncValidatorMessages } from '@/lib/async-validator';
import { responseStatusCode } from '@/lib/util';
import router from '@/router';
import store from '@/store';

momentDurationFormat(moment);

elementLocale.use(elementLangEnglish);

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(ElementUi);
Vue.use(VueI18Next);

(async () => {
  await Promise.all([
    i18next
      .use(I18NextXhrBackend)
      .use(I18NextBrowserLanguageDetector)
      .init(config.i18n),
    store.dispatch('loadUser')
      .catch(responseStatusCode(UNAUTHORIZED)),
  ]);

  i18next.on('missingKey', async (languages, namespace, key) => {
    if (!store.state.user) return;
    await axios.post('/missing-locale-update', { namespace, key });
  });

  // load resources if user is logged in
  if (store.state.user) {
    await store.dispatch('loadResources');
  }

  // Async Validator localization
  patchAsyncValidatorMessages();

  router.beforeEach((to, from, next) => {
    if (to.path !== '/login' && !store.state.user) {
      next('/login');
    } else {
      next();
    }
  });

  new Vue({
    router,
    store,
    render: h => h(App),
    i18n: new VueI18Next(i18next),
  }).$mount('#app');
})();
